import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<
  string,
  { selectedPosition: number; selectedWidth: number; disabled?: boolean }
>(
  {
    root: {
      background: 'transparent',
      display: 'flex',
      margin: '4px',
      position: 'relative',
      zIndex: 100,

      '& > button': {
        flex: '1',
        padding: '9px',
        borderRadius: '24px',
        border: 'none',
        background: 'transparent',
        fontSize: '14px',
        fontWeight: '600',
        color: '#5A00EE',
        cursor: 'pointer',
        position: 'relative',
        zIndex: 100,
      },

      '& > button.selected': {
        background: '#DACAFB',
      },
    },
    outer: {
      border: '2px solid #DACAFB',
      borderRadius: '23px',

      '&$outer.disabled': {
        opacity: '0.5',
      },
    },
    selected: {
      position: 'absolute',
      left: ({ selectedPosition }) => `${selectedPosition}%`,
      top: 0,
      bottom: 0,
      width: ({ selectedWidth }) => `${selectedWidth}%`,
      borderRadius: '24px',
      background: '#DACAFB',
      zIndex: 10,
      transition: 'left 0.3s ease-in-out',
    },
  },
  {
    name: 'ButtonToggle',
  },
);

export default useStyles;
